import {
   assertUnreachable,
   createInterpolatedTranslationKey,
   createTranslatedText,
   dateTimeMinuteFormatter,
   TranslatableText,
} from '@dreryk/react-common';
import { SecondaryText } from '@dreryk/react-components';

import { generalSettingsTranslationKeys } from '../../../../../translations';
import { PreInterviewTemplateStatus } from '../status/SurveyPreInterviewTemplateStatus';

type SurveyPreInterviewTemplateVersionProps = {
   readonly preInterviewTemplateStatus: PreInterviewTemplateStatus;
   readonly lastUpdateDate: Date;
   readonly publicationDate: Date | undefined;
   readonly defaultTemplate: boolean;
};

export const SurveyPreInterviewTemplateVersion = (props: SurveyPreInterviewTemplateVersionProps): JSX.Element => {
   const getPreInterviewTemplateVersionContent = (): TranslatableText => {
      switch (props.preInterviewTemplateStatus) {
         case 'PUBLISHED': {
            if (props.defaultTemplate) {
               return generalSettingsTranslationKeys.survey.preInterview.templateVersion.PUBLISHED.default;
            }

            return createInterpolatedTranslationKey(
               generalSettingsTranslationKeys.survey.preInterview.templateVersion.PUBLISHED.specific,
               { date: dateTimeMinuteFormatter(props.publicationDate!) }
            );
         }
         case 'NOT_PUBLISHED':
            return createInterpolatedTranslationKey(
               generalSettingsTranslationKeys.survey.preInterview.templateVersion.NOT_PUBLISHED.specific,
               { date: dateTimeMinuteFormatter(props.lastUpdateDate) }
            );
         case 'EDIT': {
            return createTranslatedText(null);
         }
         default:
            return assertUnreachable(props.preInterviewTemplateStatus);
      }
   };

   return <SecondaryText testId={'version'} compact text={getPreInterviewTemplateVersionContent()} />;
};
